import { combineReducers } from 'redux';
import _ from 'lodash';
import axios from 'axios';
import {
    LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_SUCCESS
} from '../actions/user';

import { REHYDRATE } from 'redux-persist'

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
export default function auth(state = {
    // isFetching: false,
    // isAuthenticated: false,
}, action) {
    switch (action.type) {
        case REHYDRATE: // reload page, trigger this case rehydrate
            if (action.payload && action.payload.persistent && action.payload.persistent.tokens) { // persistent.tokens를
                //체크해서 토큰이 있으면 이미 sign in한 것이고, 토큰이 없으면 sign in안한 것
                console.log("action", action.payload);

                if (!_.isNil(action.payload.persistent.tokens)) {
                    // console.log("assign token", action.payload.persistent.tokens.access);
                    axios.defaults.headers.common['Authorization'] = action.payload.persistent.tokens.access;
                }

                return Object.assign({}, state, {
                    //signin 할 때 두 가지를 체크해야 함
                    //1. authenticated 되었는지, 즉 토큰이 맞는지
                    //2. rehydrated 되었는지, 즉 local storage에 있는 info가 global state로 load되었는지
                    rehydrated: true, // "rehydrate true" means, local storage is loaded into global state!
                    isAuthenticated: !_.isNil(action.payload.persistent.tokens),
                    user: action.payload.persistent.user,
                    tokens: action.payload.persistent.tokens,
                });
            } else
                return state;
        case LOGIN_REQUEST:
            return Object.assign({}, state, {
                isAuthenticated: false
            });
        case LOGIN_SUCCESS:
            console.log("LOGIN DONE");
            console.log("HERE IS THE ACTION", action);
            if (!_.isNil( action.tokens)) {
                console.log("Set HTTP authorization token");
                axios.defaults.headers.common['Authorization'] = action.tokens.access;
            }
            return Object.assign({}, state, {
                isAuthenticated: true,
                rehydrated: true,
                user: action.user,
                tokens: action.tokens,
            });
        case LOGIN_FAILURE:
            return Object.assign({}, state, {
                isAuthenticated: false,
                errorMessage: action.message,
            });
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                isAuthenticated: false,
                user: undefined,
                tokens: undefined,
            });
        default:
            return state;
    }
}
